import { Seo } from "@/components/Seo";
import { PageHero } from "@/components/PageHero";
import { Reveal, RevealLines } from "@/components/Reveal";
import { ProjectsEditorial } from "@/components/ProjectsEditorial";
import { CtaBand } from "@/components/CtaBand";
import { ATMO, IMG } from "@/config/site";

export default function Projekte() {
  return (
    <>
      <Seo
        title="Projekte | Gartengestaltung Bremen – Hanse Garten Bremen"
        description="Gärten mit Charakter: Einblicke in Gartengestaltung, Terrassen, Rasenneuanlagen und Umgestaltungen in Bremen und Umgebung."
        path="/projekte"
        image={IMG.terrasse}
      />
      <PageHero
        eyebrow="Projekte"
        titleLines={["Gärten mit", "Charakter."]}
        text="Ausgewählte Einblicke in Flächen, die wir geplant, gebaut und gepflegt haben. Die Galerie wächst mit jedem neuen Projekt."
        image={ATMO.terrassiert}
        breadcrumb="Projekte"
      />

      <section className="bg-[#F3EDE2] py-24 md:py-36" data-testid="projects-gallery">
        <div className="mx-auto max-w-[1480px] px-5 md:px-10">
          <ProjectsEditorial />

          <Reveal delay={0.1}>
            <p className="mt-24 max-w-2xl text-sm leading-relaxed text-[#8B948A]">
              Hinweis: Die gezeigten Bilder dokumentieren unsere Leistungsbereiche und Gestaltungsprinzipien.
              Kundenbewertungen veröffentlichen wir ausschließlich, wenn sie uns tatsächlich vorliegen.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="bg-[#DCCDB4]/30 py-24 md:py-32">
        <div className="mx-auto max-w-[1200px] px-5 text-center md:px-10">
          <p className="eyebrow">Zusammenarbeit</p>
          <RevealLines
            lines={["Ihr Garten", "könnte der nächste sein."]}
            as="h2"
            className="display-xl mx-auto mt-6 text-[10vw] leading-[0.92] text-[#17251C] md:text-[4vw]"
          />
        </div>
      </section>

      <CtaBand />
    </>
  );
}
